import React, { Fragment } from 'react';
import Navbar from '../../../components/Navbar';
import UnassignedAssetsGridWrapper from './components/UnassignedAssetsGridWrapper';

export const UnassignedAssets = () => {
  return (
    <Fragment>
      <Navbar />
      <h2 className="ml-5 mt-2">Unassigned Assets</h2>
      <h5 className="ml-5 mt-2">
        The following assets have unknown physical owners that could not be assigned a department:
      </h5>
      <UnassignedAssetsGridWrapper />
    </Fragment>
  );
};
